import React from 'react'

interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  value?: string
  onChange?: (event: React.ChangeEvent<HTMLTextAreaElement>) => void
  disabled?: boolean
  invalid?: boolean
}

export const Textarea: React.FC<TextareaProps> = ({ invalid, style, ...props }) => {
  return (
    <textarea
      {...props}
      style={{
        width: '100%',
        padding: '8px 12px',
        border: `1px solid ${invalid ? '#d91515' : '#ccc'}`,
        borderRadius: '4px',
        fontSize: '1rem',
        resize: 'vertical',
        minHeight: '80px',
        ...style,
        fontFamily:
          '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif !important',
      }}
    />
  )
}
